import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  FormControlLabel,
  RadioGroup,
  Radio,
  Paper
} from '@material-ui/core';
import './style.css'
import OverLoader from '../../components/common/loader';
import { EditUserAccessRight, GetUserAccessRight } from './usersAction';

class AccessRight extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDeleteContactDialogOpen: false,
      accessRights: '',
      systemSettings: '0',
      userCategories: '0',
      consultantFunctions: '0',
      consultantCategories: '0',
      users: '0',
      classifications: '0',
      branches: '0',
      theme: '0',
      countries: '0',
      publicHolidays: '0',
      customers: '0',
      project_planning_all_over: '0',
      projectsBaseDataOwn: '0',
      projectsSettingOwn: '0',
      projectsFeeOwn: '0',
      projectsCapacityOwn: '0',
      projectsConsultantsOwn: '0',
      projectsInvoicesOwn: '0',
      projectsBasedataForOther: '0',
      projectsSettingOther: '0',
      projectsFeeOther: '0',
      projectsCapacityOther: '0',
      projectsConsultantsOther: '0',
      projectsInvoicesOther: '0',
      projectPlanningForOwn: '0',
      projectPlanningForOther: '0',
      projectActivityOwn: '0',
      projectActivityOther: '0',
      timeRegistrationOwn: '0',
      timeRegistrationOther: '0',
      leads: '0',
      monthsPlan: '0',
      consultantPlan: '0',
      consultantPlanOwn: '0',
      yearOverviewCustomers: '0',
      yearOverviewProjects: '0',
      vacationOverview: '0',
      ressourcePlanning: '0',
      yearOverviewConsultants: '0',
      yearOverviewStudents: '0',
      yearOverviewThemes: '0',
      yearOverviewLeads: '0',
      archive: '0',
      accessError: false,
    }
    this.baseState = this.state;

  }

  componentDidMount = () => {
    const { userId, GetUserAccessRight } = this.props
    GetUserAccessRight(userId)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { user_access_rights, access_error, userId, isBlockingCheckfalse } = this.props
    if (nextProps.user_access_rights !== user_access_rights) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user.id === userId) {
        localStorage.setItem("access_right", JSON.stringify(nextProps.user_access_rights));
      }
      this.setState({
        accessRights: nextProps.user_access_rights,
        systemSettings: nextProps.user_access_rights.system_settings,
        userCategories: nextProps.user_access_rights.user_categories,
        consultantFunctions: nextProps.user_access_rights.consultant_functions,
        consultantCategories: nextProps.user_access_rights.consultant_categories,
        users: nextProps.user_access_rights.users,
        classifications: nextProps.user_access_rights.classifications,
        branches: nextProps.user_access_rights.branches,
        theme: nextProps.user_access_rights.themes,
        countries: nextProps.user_access_rights.countries,
        publicHolidays: nextProps.user_access_rights.public_holidays,
        customers: nextProps.user_access_rights.customers,
        projectsBaseDataOwn: nextProps.user_access_rights.projects_basedata_for_own,
        projectsSettingOwn: nextProps.user_access_rights.projects_setting_for_own,
        projectsFeeOwn: nextProps.user_access_rights.projects_fee_for_own,
        projectsCapacityOwn: nextProps.user_access_rights.projects_capacity_for_own,
        projectsConsultantsOwn: nextProps.user_access_rights.projects_consultants_for_own,
        projectsInvoicesOwn: nextProps.user_access_rights.projects_invoices_for_own,
        projectsBasedataForOther: nextProps.user_access_rights.projects_basedata_for_other,
        projectsSettingOther: nextProps.user_access_rights.projects_setting_for_other,
        projectsFeeOther: nextProps.user_access_rights.projects_fee_for_other,
        projectsCapacityOther: nextProps.user_access_rights.projects_capacity_for_other,
        projectsConsultantsOther: nextProps.user_access_rights.projects_consultants_for_other,
        projectsInvoicesOther: nextProps.user_access_rights.projects_invoices_for_other,
        projectActivityOwn: nextProps.user_access_rights.projects_activity_for_own,
        projectActivityOther: nextProps.user_access_rights.projects_activity_for_other,
        projectPlanningForOwn: nextProps.user_access_rights.projects_planning_for_own,
        projectPlanningForOther: nextProps.user_access_rights.projects_planning_for_other,
        project_planning_all_over: nextProps.user_access_rights.project_planning_all_over,
        timeRegistrationOwn: nextProps.user_access_rights.time_reg_for_own,
        timeRegistrationOther: nextProps.user_access_rights.time_reg_other_consultants_other,
        leads: nextProps.user_access_rights.leads,
        monthsPlan: nextProps.user_access_rights.months_plan,
        consultantPlan: nextProps.user_access_rights.consultant_plan,
        consultantPlanOwn: nextProps.user_access_rights.consultant_plan_for_own,
        yearOverviewCustomers: nextProps.user_access_rights.year_overview_customers,
        yearOverviewProjects: nextProps.user_access_rights.year_overview_projects,
        yearOverviewConsultants: nextProps.user_access_rights.year_overview_consultants,
        yearOverviewStudents: nextProps.user_access_rights.year_overview_students,
        yearOverviewThemes: nextProps.user_access_rights.year_overview_themes,
        vacationOverview: nextProps.user_access_rights.year_overview_vacation,
        ressourcePlanning: nextProps.user_access_rights.year_overview_resource_planning,
        yearOverviewLeads: nextProps.user_access_rights.year_overview_leads,
        archive: nextProps.user_access_rights.archive,
      }, () => isBlockingCheckfalse())
    }
    if (nextProps.access_error !== access_error) {
      this.setState({ accessError: true })
    }
  }

  render() {
    const {
      isDeleteContactDialogOpen,
      systemSettings,
      userCategories,
      consultantFunctions,
      consultantCategories,
      users,
      classifications,
      branches,
      theme,
      countries,
      publicHolidays,
      customers,
      projectsBaseDataOwn,
      projectsSettingOwn,
      projectsFeeOwn,
      projectsCapacityOwn,
      projectsConsultantsOwn,
      projectsInvoicesOwn,
      projectsBasedataForOther,
      projectsSettingOther,
      projectsFeeOther,
      projectsCapacityOther,
      projectsConsultantsOther,
      projectsInvoicesOther,
      projectActivityOwn,
      projectActivityOther,
      projectPlanningForOwn,
      projectPlanningForOther,
      timeRegistrationOwn,
      timeRegistrationOther,
      leads,
      monthsPlan,
      consultantPlan,
      yearOverviewCustomers,
      yearOverviewProjects,
      yearOverviewConsultants,
      yearOverviewStudents,
      yearOverviewThemes,
      vacationOverview,
      ressourcePlanning,
      yearOverviewLeads,
      archive,
      project_planning_all_over,
      consultantPlanOwn,
      accessError } = this.state
    const { isloading, isBlockingCheck } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    return (
      <div className="usercategoryTable">
        {isloading && <OverLoader />}
        {Number(access_rights.consultant_categories) !== 0 ?
          <Fragment>
            <div
              className={`${Number(access_rights.consultant_categories) === 1 ? "disableALlFields" : ""}`}
            >
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Funktionen</TableCell>
                      <TableCell align="center" colSpan={3}>Eigene Projekte</TableCell>
                      <TableCell align="center" colSpan={3} className="br-0">Alle Projekte</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Berechtigung
                          </TableCell>
                      <TableCell align="center">Keine</TableCell>
                      <TableCell align="center">Lesen</TableCell>
                      <TableCell align="center">Ändern</TableCell>
                      <TableCell align="center">Keine</TableCell>
                      <TableCell align="center">Lesen</TableCell>
                      <TableCell align="center" className="br-0">Ändern</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Systemeinstellungen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={systemSettings} onChange={(e) => this.setState({ systemSettings: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Benutzerkategorien
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={userCategories} onChange={(e) => this.setState({ userCategories: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Beraterfunktionen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={consultantFunctions} onChange={(e) => this.setState({ consultantFunctions: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Benutzer
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={users} onChange={(e) => this.setState({ users: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Benutzer, Zugriffsrechte
                        </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={consultantCategories} onChange={(e) => this.setState({ consultantCategories: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Einstufungen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={classifications} onChange={(e) => this.setState({ classifications: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Branchen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={branches} onChange={(e) => this.setState({ branches: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Themen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={theme} onChange={(e) => this.setState({ theme: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Länder
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={countries} onChange={(e) => this.setState({ countries: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Feiertage
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={publicHolidays} onChange={(e) => this.setState({ publicHolidays: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Kunden
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={customers} onChange={(e) => this.setState({ customers: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Planung überall
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={project_planning_all_over} onChange={(e) => this.setState({ project_planning_all_over: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Stammdaten
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsBaseDataOwn} onChange={(e) => this.setState({ projectsBaseDataOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsBasedataForOther} onChange={(e) => this.setState({ projectsBasedataForOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, auf 100% setzen
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsSettingOwn} onChange={(e) => this.setState({ projectsSettingOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsSettingOther} onChange={(e) => this.setState({ projectsSettingOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Honorar
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsFeeOwn} onChange={(e) => this.setState({ projectsFeeOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsFeeOther} onChange={(e) => this.setState({ projectsFeeOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Kapazität
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsCapacityOwn} onChange={(e) => this.setState({ projectsCapacityOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsCapacityOther} onChange={(e) => this.setState({ projectsCapacityOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Berater
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsConsultantsOwn} onChange={(e) => this.setState({ projectsConsultantsOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsConsultantsOther} onChange={(e) => this.setState({ projectsConsultantsOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Planung
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectPlanningForOwn} onChange={(e) => this.setState({ projectPlanningForOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectPlanningForOther} onChange={(e) => this.setState({ projectPlanningForOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Rechnungen
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsInvoicesOwn} onChange={(e) => this.setState({ projectsInvoicesOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectsInvoicesOther} onChange={(e) => this.setState({ projectsInvoicesOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell component="th" scope="row">
                        Projekte, Tätigkeiten
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectActivityOwn} onChange={(e) => this.setState({ projectActivityOwn: e.target.value },()=> isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={projectActivityOther} onChange={(e) => this.setState({ projectActivityOther: e.target.value },()=> isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Stundenerfassung
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={timeRegistrationOwn} onChange={(e) => this.setState({ timeRegistrationOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={timeRegistrationOther} onChange={(e) => this.setState({ timeRegistrationOther: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Akquiseliste
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={leads} onChange={(e) => this.setState({ leads: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="2" control={<Radio />} /></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        6-Monatsplan
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={monthsPlan} onChange={(e) => this.setState({ monthsPlan: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Beraterplan
                          </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={consultantPlanOwn} onChange={(e) => this.setState({ consultantPlanOwn: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={consultantPlan} onChange={(e) => this.setState({ consultantPlan: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Jahresübersicht Kunden
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewCustomers} onChange={(e) => this.setState({ yearOverviewCustomers: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Jahresübersicht Projekte
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewProjects} onChange={(e) => this.setState({ yearOverviewProjects: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Jahresübersicht Berater
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewConsultants} onChange={(e) => this.setState({ yearOverviewConsultants: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                      Jahresübersicht Studenten
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewStudents} onChange={(e) => this.setState({ yearOverviewStudents: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Jahresübersicht Themen
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewThemes} onChange={(e) => this.setState({ yearOverviewThemes: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Jahresübersicht Leads
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={yearOverviewLeads} onChange={(e) => this.setState({ yearOverviewLeads: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Urlaubsübersicht
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={vacationOverview} onChange={(e) => this.setState({ vacationOverview: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Ressourcenplanung
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={ressourcePlanning} onChange={(e) => this.setState({ ressourcePlanning: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Archiv
                          </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center" colSpan="3" className="zeroPadded">
                        <RadioGroup name="system_settings" value={archive} onChange={(e) => this.setState({ archive: e.target.value }, () => isBlockingCheck())}>
                          <Table aria-label="simple table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"><FormControlLabel value="0" control={<Radio />} /></TableCell>
                                <TableCell align="center"><FormControlLabel value="1" control={<Radio />} /></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {!(Number(access_rights.consultant_categories) === 1) &&
              <div className="actionBtn">
                <Button variant="outlined" color="primary" onClick={() => { this.editAccessRights() }} >Speichern</Button>
                <Button variant="outlined" color="secondary" onClick={() => { this.openDeleteDialog() }} >Abbrechen</Button>
              </div>
            }
          </Fragment>
          :
          <h3>Access Denied</h3>
        }
        <Dialog
          open={isDeleteContactDialogOpen}
        >
          <DialogTitle>Benutzerkategorien löschen</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Sind Sie sicher?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.AbortAdding} size="small" variant="outlined" color="primary" autoFocus>
              Bestätigen
                      </Button>
            <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary" >
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })
  }
  AbortAdding = () => {
    const { isBlockingCheckfalse } = this.props
    this.setState(this.baseState)
    isBlockingCheckfalse()
  }

  editAccessRights = () => {
    const dataObj = this.state
    const { EditUserAccessRight, userId } = this.props;
    EditUserAccessRight(userId, dataObj)
  }
}

const mapStateToProps = ({ usersData }) => {
  return {
    isloading: usersData.loading,
    user_access_rights: usersData.user_access_rights,
    access_error: usersData.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    EditUserAccessRight: (id, obj) => dispatch(EditUserAccessRight(id, obj)),
    GetUserAccessRight: (id) => dispatch(GetUserAccessRight(id)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AccessRight)